<div class="grid grid-nogutter p-fluid m-0">
    <div class="col-5" [formGroup]="form">
        <div class="s-select-week__switch">
            <p-inputSwitch formControlName="switch" class="flex aling-items-center" (onChange)="toggle()"></p-inputSwitch>
            <span class="s-select-week__label">{{weekLabel[form.value.weekDay ?? 0]}}</span>
        </div>
    </div>
    <div class="col-7" [formGroup]="form">
        <ng-container *ngIf="form.value.switch" formArrayName="periods">
            <div class="grid grid-nogutter align-items-center">
                <ng-container *ngFor="let periodForm of periods.controls; let i = index">
                    <ng-container [formGroup]="periodForm">
                        <div class="col-4 mb-3">
                            <!-- <p-dropdown formControlName="horarioIni" [options]="horarios" appendTo="body"></p-dropdown> -->
                            <input type="time" step="300" class="p-1" pInputText formControlName="horarioIni" [disabled]="disabled">
                        
                        </div>
                        <div class="col-1 text-center mb-3"><span>:</span></div>
                        <div class="col-4 mb-3">
                            <!-- <p-dropdown formControlName="horarioFim" [options]="horarios" appendTo="body"></p-dropdown> -->
                            <input type="time" step="300" class="p-1" pInputText formControlName="horarioFim" [disabled]="disabled">
                            <!-- <input type="time" style="width: 100%;" formControlName="horarioFim" placeholder="Teste 2"> -->
                            <!-- <button (click)="addPeriod()">+</button> -->
                        </div>
                        <div class="col-3 text-right mb-3">
                            <img *ngIf="periods.controls.length > 1" class="s-select-week__button" src="/assets/icons/tabler_circle-minus.svg" (click)="removePeriod(i)">
                            <img *ngIf="periods.controls.length == (i+1)" class="s-select-week__button" src="/assets/icons/tabler_circle-plus.svg" (click)="addPeriod()">
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </ng-container>
    </div>
</div>